webpackJsonp([133386337597581],{

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(159);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Link = function Link(_ref) {
	  var to = _ref.to,
	      props = _objectWithoutProperties(_ref, ['to']);
	
	  var isExternalLink = false;
	  if (/^https?:\/\/.*/.test(to)) {
	    isExternalLink = true;
	  }
	
	  return isExternalLink ? Glamor.createElement('a', _extends({ href: to }, props)) : Glamor.createElement(_gatsbyLink2.default, _extends({ to: to }, props));
	};
	
	Link.propTypes = {
	  to: _propTypes2.default.string
	};
	
	exports.default = Link;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _link = __webpack_require__(55);
	
	var _link2 = _interopRequireDefault(_link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PreviousPageNavigation = function PreviousPageNavigation(_ref) {
	  var hasPreviousPage = _ref.hasPreviousPage,
	      currentPage = _ref.currentPage,
	      categoryPath = _ref.categoryPath;
	  return hasPreviousPage ? Glamor.createElement(
	    _link2.default,
	    {
	      to: '/' + categoryPath + (currentPage - 1 === 1 ? '/' : '/' + (currentPage - 1) + '/'),
	      css: {
	        color: '#25ced1',
	        textDecoration: 'none'
	      }
	    },
	    '< Prev'
	  ) : Glamor.createElement(
	    'p',
	    {
	      css: {
	        color: '#979797',
	        margin: '0'
	      }
	    },
	    '< Prev'
	  );
	};
	
	var NextPageNavigation = function NextPageNavigation(_ref2) {
	  var hasNextPage = _ref2.hasNextPage,
	      currentPage = _ref2.currentPage,
	      categoryPath = _ref2.categoryPath;
	  return hasNextPage ? Glamor.createElement(
	    _link2.default,
	    {
	      to: '/' + categoryPath + '/' + (currentPage + 1) + '/',
	      css: {
	        color: '#25ced1',
	        textDecoration: 'none'
	      }
	    },
	    'Next >'
	  ) : Glamor.createElement(
	    'p',
	    {
	      css: {
	        color: '#979797',
	        margin: '0'
	      }
	    },
	    'Next >'
	  );
	};
	
	var Pagination = function Pagination(_ref3) {
	  var hasPreviousPage = _ref3.hasPreviousPage,
	      hasNextPage = _ref3.hasNextPage,
	      currentPage = _ref3.currentPage,
	      categoryPath = _ref3.categoryPath;
	  return Glamor.createElement(
	    'div',
	    {
	      css: {
	        maxWidth: '300px',
	        margin: '0 auto 2rem',
	        padding: '1rem 1.5rem'
	      }
	    },
	    Glamor.createElement(
	      'div',
	      {
	        css: {
	          display: 'inline-block',
	          textAlign: 'left',
	          width: 'calc(100% / 3)'
	        }
	      },
	      Glamor.createElement(PreviousPageNavigation, {
	        hasPreviousPage: hasPreviousPage,
	        currentPage: currentPage,
	        categoryPath: categoryPath
	      })
	    ),
	    Glamor.createElement(
	      'div',
	      {
	        css: {
	          display: 'inline-block',
	          textAlign: 'center',
	          width: 'calc(100% / 3)'
	        }
	      },
	      Glamor.createElement(
	        'span',
	        null,
	        currentPage
	      )
	    ),
	    Glamor.createElement(
	      'div',
	      {
	        css: {
	          display: 'inline-block',
	          textAlign: 'right',
	          width: 'calc(100% / 3)'
	        }
	      },
	      Glamor.createElement(NextPageNavigation, {
	        hasNextPage: hasNextPage,
	        currentPage: currentPage,
	        categoryPath: categoryPath
	      })
	    )
	  );
	};
	
	Pagination.propTypes = {
	  hasNextPage: _propTypes2.default.bool,
	  hasPreviousPage: _propTypes2.default.bool,
	  currentPage: _propTypes2.default.number,
	  categoryPath: _propTypes2.default.string
	};
	
	PreviousPageNavigation.propTypes = {
	  hasPreviousPage: _propTypes2.default.bool,
	  currentPage: _propTypes2.default.number,
	  categoryPath: _propTypes2.default.string
	};
	
	NextPageNavigation.propTypes = {
	  hasNextPage: _propTypes2.default.bool,
	  currentPage: _propTypes2.default.number,
	  categoryPath: _propTypes2.default.string
	};
	
	exports.default = Pagination;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _link = __webpack_require__(55);
	
	var _link2 = _interopRequireDefault(_link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var LinkTag = function LinkTag(_ref) {
	  var href = _ref.href,
	      children = _ref.children,
	      props = _objectWithoutProperties(_ref, ['href', 'children']);
	
	  return href ? Glamor.createElement(
	    'a',
	    _extends({ href: href }, props),
	    children
	  ) : Glamor.createElement(
	    'span',
	    props,
	    children
	  );
	};
	
	var StoryList = function StoryList(_ref2) {
	  var id = _ref2.id,
	      score = _ref2.score,
	      url = _ref2.url,
	      title = _ref2.title,
	      by = _ref2.by,
	      timeISO = _ref2.timeISO,
	      descendants = _ref2.descendants,
	      domain = _ref2.domain;
	  return Glamor.createElement(
	    'div',
	    {
	      css: {
	        alignItems: 'center',
	        backgroundColor: '#fffffc',
	        border: '1px solid #bdbdbd',
	        borderRadius: '5px',
	        display: 'flex',
	        margin: '0 0 2rem',
	        padding: '2rem 0',
	        width: '100%'
	      }
	    },
	    Glamor.createElement(
	      'div',
	      {
	        css: {
	          display: 'inline-block',
	          padding: '0 1rem 0 2rem',
	          width: '85px',
	          '@media (max-width: 485px)': {
	            padding: '0 1rem',
	            width: '60px'
	          }
	        }
	      },
	      Glamor.createElement(
	        'p',
	        {
	          css: {
	            color: '#25ced1',
	            fontSize: '2rem',
	            fontWeight: 'bold',
	            textAlign: 'center',
	            '@media (max-width: 485px)': {
	              fontSize: '1.8rem'
	            }
	          }
	        },
	        score
	      )
	    ),
	    Glamor.createElement(
	      'div',
	      {
	        css: {
	          display: 'inline-block',
	          padding: '0 2rem 0 1rem',
	          width: 'calc(100% - 85px)',
	          '@media (max-width: 485px)': {
	            padding: '0 1rem',
	            width: 'calc(100% - 60px)'
	          }
	        }
	      },
	      Glamor.createElement(
	        'p',
	        {
	          css: {
	            fontSize: '1.8rem',
	            marginBottom: '0.6rem',
	            '@media (max-width: 485px)': {
	              fontSize: '1.6rem',
	              lineHeight: '1.33'
	            }
	          }
	        },
	        Glamor.createElement(
	          LinkTag,
	          {
	            href: url,
	            css: {
	              color: 'rgba(0, 0, 0, 0.85)',
	              textDecoration: 'none'
	            }
	          },
	          title
	        )
	      ),
	      Glamor.createElement(
	        'p',
	        {
	          css: {
	            color: '#979797',
	            lineHeight: '1.5',
	            margin: '0',
	            '@media (max-width: 485px)': {
	              fontSize: '1.4rem'
	            }
	          }
	        },
	        by,
	        ' - ',
	        timeISO,
	        ' -',
	        ' ',
	        Glamor.createElement(
	          _link2.default,
	          {
	            to: '/comment/' + id + '/',
	            css: {
	              color: '#25ced1',
	              textDecoration: 'none',
	              '@media (max-width: 485px)': {
	                fontSize: '1.4rem'
	              }
	            }
	          },
	          descendants || 0,
	          ' ',
	          descendants && descendants > 1 ? 'comments' : 'comment'
	        ),
	        ' ',
	        domain && '- (' + domain + ')' || ''
	      )
	    )
	  );
	};
	
	LinkTag.propTypes = {
	  href: _propTypes2.default.string,
	  children: _propTypes2.default.any
	};
	
	StoryList.propTypes = {
	  id: _propTypes2.default.string,
	  by: _propTypes2.default.string,
	  title: _propTypes2.default.string,
	  url: _propTypes2.default.string,
	  score: _propTypes2.default.number,
	  order: _propTypes2.default.number,
	  domain: _propTypes2.default.string,
	  category: _propTypes2.default.string,
	  descendants: _propTypes2.default.number,
	  timeISO: _propTypes2.default.string,
	  childrenHnComment: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    text: _propTypes2.default.string,
	    by: _propTypes2.default.string,
	    timeISO: _propTypes2.default.string
	  }))
	};
	
	exports.default = StoryList;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _storyListItem = __webpack_require__(210);
	
	var _storyListItem2 = _interopRequireDefault(_storyListItem);
	
	var _pagination = __webpack_require__(209);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HackerNewsCategoryTemplate = function HackerNewsCategoryTemplate(_ref) {
	  var _ref$pathContext = _ref.pathContext,
	      stories = _ref$pathContext.stories,
	      hasNextPage = _ref$pathContext.hasNextPage,
	      hasPreviousPage = _ref$pathContext.hasPreviousPage,
	      currentPage = _ref$pathContext.currentPage,
	      categoryPath = _ref$pathContext.categoryPath;
	  return Glamor.createElement(
	    'div',
	    {
	      css: {
	        marginBottom: '2rem',
	        width: '100%'
	      }
	    },
	    Glamor.createElement(_pagination2.default, {
	      hasNextPage: hasNextPage,
	      hasPreviousPage: hasPreviousPage,
	      currentPage: currentPage,
	      categoryPath: categoryPath
	    }),
	    stories.map(function (story, index) {
	      return Glamor.createElement(_storyListItem2.default, _extends({ key: index }, story));
	    })
	  );
	};
	
	HackerNewsCategoryTemplate.propTypes = {
	  pathContext: _propTypes2.default.shape({
	    stories: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      id: _propTypes2.default.string,
	      by: _propTypes2.default.string,
	      title: _propTypes2.default.string,
	      url: _propTypes2.default.string,
	      score: _propTypes2.default.number,
	      order: _propTypes2.default.number,
	      domain: _propTypes2.default.string,
	      category: _propTypes2.default.string,
	      descendants: _propTypes2.default.number,
	      timeISO: _propTypes2.default.string,
	      childrenHnComment: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        text: _propTypes2.default.string,
	        by: _propTypes2.default.string,
	        timeISO: _propTypes2.default.string
	      }))
	    }))
	  })
	};
	
	exports.default = HackerNewsCategoryTemplate;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-hacker-news-category-js-665a399ccfcb6642945c.js